import { useEffect } from "react";
import { DockviewApi, DockviewPanelApi } from "dockview-react";

interface UseCtrlDMarkOptions {
  onTrigger: () => void;
  getNextScrollKey?: () => string | null | undefined;
  panelApi?: DockviewPanelApi;
  containerApi?: DockviewApi;
}

export function useCtrlDMark({ onTrigger, getNextScrollKey, panelApi, containerApi }: UseCtrlDMarkOptions) {
  useEffect(() => {
    const keyHandler = (e: KeyboardEvent) => {
      if (!((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === "d")) return;
      if (panelApi && containerApi && containerApi.activePanel?.id !== panelApi.id) return;
      e.preventDefault();
      e.stopPropagation();
      (e as any).stopImmediatePropagation?.();
      const key = getNextScrollKey?.();
      onTrigger();
      if (key) {
        document.getElementById(key)?.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    };
    window.addEventListener("keydown", keyHandler, { capture: true });
    return () => window.removeEventListener("keydown", keyHandler, { capture: true } as any);
  }, [panelApi, containerApi, onTrigger, getNextScrollKey]);
}
